module.exports = __webpack_public_path__ + "static/media/wseLOGO.55c3b62f.png";